module.exports = "<lottie-player slot=\"end\" autoplay mode=\"normal\" loop count=\"2\" [src]=\"srcElement\">\r\n</lottie-player>\r\n"